// extracted by mini-css-extract-plugin
export default {"container":"PaginaPadrao_container__tDqwk","container-outlet":"PaginaPadrao_container-outlet__QEoEZ"};